<template>
    <div id="addConsignment">
        <a-modal v-model="visible" :title="labelName" :maskClosable="false">
            <template slot="footer">
                <a-button size="small" type="primary" @click="cancel">{{ $t('publicLang.Close') }}</a-button>
                <a-button size="small" type="primary" @click="save">{{ $t('roleGe.Save') }}</a-button>

            </template>
            <a-form :form="form">
                <label>{{contentText}}</label>
                <a-form-item :label="labelName"  v-bind="formItemLayout">
                    <a-input
                            type="number"
                        size="small"
                        v-decorator="['fromValue', { rules: [{ required: requiredFalse}] }]"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                labelName: '',
                ajaxtype: '',
                contentText:'',
                params: {},
                visible: false,
                requiredFalse:true,
                form:this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        methods:{
            show(name,type,params){
                this.params = params
                this.labelName = name
                this.visible = true
                this.ajaxtype = type


                this.form.resetFields();
                this.contentText = '';
                if(this.ajaxtype == 'addCycleCountDefaultValue') {
                    this.requiredFalse = false;
                    this.contentText = this.$t('cycleCountMaster.createCountOrderByNumber');
                }
            },
            save(){
                this.form.validateFields((error, values)=>{
                    if(!error){
                       let params = {}
                       let ajaxTypeName = ''
                       if(this.ajaxtype == 'addCycleCountDefaultValue'){
                           let returnValue = values.fromValue == undefined||values.fromValue == null?'':values.fromValue;
                           this.$emit('afterSave',returnValue,this.params);
                           this.visible = false;
                       }
                    }
                })
            },
            cancel() {
                this.visible = false;
            }
        }
    }
</script>